<div class="cmps-cdk-d-flex">
    <div
        class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mr-1dot5"
        [class.flex-row]="!labelsOnTop"
        [class.cmps-cdk-align-items-center]="!labelsOnTop"
        [class.flex-column]="labelsOnTop"
    >
        <div class="cmps-cdk-mr-0dot5">
            {{ _i18n._9774_START_DATE_ | translate }}
        </div>
        <div class="cmps-cdk-d-flex">
            <input
                type="text"
                class="cmps-form-input cmps-date-range--input"
                readonly
                ngbDatepicker
                [minDate]="_minFromDate"
                [maxDate]="_maxFromDate"
                [placement]="fromDatePlacement ?? 'bottom-left'"
                [ngModel]="dateRange?.from"
                (ngModelChange)="_onFromChange($event)"
                (click)="dpFrom.toggle()"
                #dpFrom="ngbDatepicker"
            />
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [attr.aria-expanded]="dpFrom.isOpen()"
                (click)="dpFrom.toggle()"
            >
                <cmps-icon
                    class="formIcon"
                    svgIcon="calendar-range"
                ></cmps-icon>
            </button>
        </div>
    </div>

    <div
        class="cmps-cdk-d-flex cmps-cdk-align-items-center"
        [class.flex-row]="!labelsOnTop"
        [class.cmps-cdk-align-items-center]="!labelsOnTop"
        [class.flex-column]="labelsOnTop"
    >
        <div class="cmps-cdk-mr-0dot5">
            {{ _i18n._73_END_DATE_ | translate }}
        </div>
        <div class="cmps-cdk-d-flex">
            <input
                type="text"
                class="cmps-form-input cmps-date-range--input"
                readonly
                ngbDatepicker
                [minDate]="_minToDate"
                [maxDate]="_maxToDate"
                [placement]="toDatePlacement ?? 'bottom-left'"
                [ngModel]="dateRange?.to"
                (ngModelChange)="_onToChange($event)"
                (click)="dpTo.toggle()"
                #dpTo="ngbDatepicker"
            />
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [attr.aria-expanded]="dpTo.isOpen()"
                (click)="dpTo.toggle()"
            >
                <cmps-icon
                    class="formIcon"
                    svgIcon="calendar-range"
                ></cmps-icon>
            </button>
        </div>
    </div>
</div>
